import { defineComponent as _defineComponent } from 'vue'
import UserInfo from './UserInfo.vue';
// 【language】功能待完善
// import Language from './Language.vue';
import NetworkInfo from './NetworkInfo.vue';
// 【info】功能待完善
import InfoControl from './InfoControl.vue';
import LayoutControl from './LayoutControl.vue';
import { useBasicStore } from '../../../stores/basic';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ['log-out'],
  setup(__props) {

const basicStore = useBasicStore();

const { userId, userName, userAvatar, userRole,roomInfos } = storeToRefs(basicStore);



return { __sfc: true,basicStore, userId, userName, userAvatar, userRole, roomInfos, UserInfo, NetworkInfo, LayoutControl }
}

})